module.exports = {
    RGBtoRGBA: function(color, alpha) {
        if (color === null)
            return null;

        if (color.length != 7)
            throw new Error("invalid RGB color string");

        let R = parseInt(color.substring(1, 3), 16);
        let G = parseInt(color.substring(3, 5), 16);
        let B = parseInt(color.substring(5, 7), 16);

        if (!alpha)
            alpha = "1.0";

        return "rgba(" + R + "," + G + "," + B + "," + alpha + ")";
    }
};




/** WEBPACK FOOTER **
 ** ./src/app/utils/color.js
 **/